module.exports = __webpack_public_path__ + "static/media/MW.3a771f57.svg";